import type { TaskType } from './constants';

export function getTrackingDataForTask(taskName: TaskType): { task: string; platform?: string } {
	switch (taskName) {
		case 'complete_profile':
			return { task: 'profile' };
		case 'share_facebook':
			return { task: 'share_social', platform: 'facebook' };
		case 'share_instagram':
			return { task: 'share_social', platform: 'instagram' };
		default:
			return { task: taskName };
	}
}
